import Config from 'config';

import DateUtil from 'js/common/date/date-util';
import SheetViewTypes from 'js/sheet-view/sheet-view-types';
import GridCommon from 'js/sheet-view/grid/grid-common'
import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';

import GridRecordDisplay from 'js/sheet-view/grid/grid-record-display';
import BackgroundBus from 'js/bus/background-bus';

const COMMON_VUE_FUNCTIONS = {
	methods:{
		runRecordLoad(dataStore){
			const vcSelf = this;
			vcSelf.loadingRecords = true;
			vcSelf.hideUntilLoadCompletes = true;

			let ordering = [{
				target: 'context',
				property: 'datetime',
				order: 'asc',
			}];
			dataStore.$internals.graphManager.filterEdges({
				inboundIncludes:[{
					filters:{
						edges:{
							name:{
								eq:'dataStore',
							}
						},
						meta:{
							type:{
								eq:'Record',
							}
						},
						payload:{
							active:{
								eq: true,
							},
						}
					},
					options:{
						applyPerBranch: true,
						edgeGroup: 'records',
						limit: Config.dataStore.loading.maximumRecordsToLoad,
						ordering,
					},
					linkedObjects:{
						includes:[{
							filters:{
								edges:{
									name:{
										startswith:'fieldValues.',
										endswith:'.value',
									},
								},
								meta:{
									type:{
										eq: 'ExternalEntityObject',
									}
								}
							},
							options:{
								applyPerBranch: false,
								edgeGroup: 'eeos',
								limit: Config.dataStore.loading.maximumRecordsToLoad,
							},
						},{
							filters:{
								edges:{
									name:{
										startswith:'fieldValues.',
										endswith:'.valueEdge',
									},
								},
								meta:{
									type:{
										eq: 'ExternalEntityObject',
									}
								}
							},
							options:{
								applyPerBranch: false,
								edgeGroup: 'valueEdges',
								limit: Config.dataStore.loading.maximumRecordsToLoad,
							},
						}]
					}
				}]
			}, function onLoadBack(edgesBack, {edgeGroups}, ...args) {
				vcSelf.$pubsub.modules.ActiveWorkbook.pub('workbookAvailable', true);
				vcSelf.loadingRecords = false;
				vcSelf.hideUntilLoadCompletes = false;
				vcSelf.loadedRecords = edgeGroups.records.map(function getFromObject(edge){
					return edge.from;
				});
			});
		},
		runOROLoad(dataStore) {
			const vcSelf = this;
			// Find all connections
			const connections = dataStore.meta.schema.getArrayOfFieldsGUIDsMatchingType("externalEntityLink");
			const oroFilters = connections.reduce(function toFilters(array, eelFieldGUID) {
				const connectedAppName = dataStore.meta.schema.fields[eelFieldGUID].field.attributes.connectedAppName;
				// Fetch the latest successful sync and import for each connection. Note we must do this per connection (which may have overlapping connected app names) since we want the latest activity for each connection, not each connected app name
				return [...array, {
					filters: {
						edges: {
							name: {
								eq: "operationBody.externalOperationParams.dataStore"
							}
						},
						meta: {
							type: {
								eq: "OperationRequestObject"
							}
						},
						payload: {
							and: [{
								or: [{
									and: [{ // Fetch successfully completed sync
										"operationBody__externalOperationName": {
											eq: "commitSync"
										},
										"operationBody__connectedAppName": {
											eq: connectedAppName
										},
										"operationBody__externalOperationParams__options__includedEELGUIDs": {
											or: [{
												isnull: true
											}, {
												contains: eelFieldGUID
											}]
										},
										"statusUpdates__-1__status": {
											eq: "Done"
										},
										"operationSucessfullyCompleted": {
											eq: true
										}
									}]
								}, {
									and: [{ // Fetch processing syncs
										"operationBody__externalOperationName": {
											eq: "commitSync"
										},
										"operationBody__connectedAppName": {
											eq: connectedAppName
										},
										"operationBody__externalOperationParams__options__includedEELGUIDs": {
											or: [{
												isnull: true
											}, {
												contains: eelFieldGUID
											}]
										},
										"!statusUpdates__-1__status": {
											eq: "Done"
										},
										"statusUpdates__-1__timestamp": {
											gt: (new Date()).getTime() - vcSelf.$root.VisorGlobalConfig.dataStore.operationRequests.abandonedTimeoutMS
										}
									}]
								}]
							}]
						}
					},
					linkedObjects: {
						includes: [{
							filters: {
								edges: {
									name: {
										eq: "creator",
									}
								},
								meta: {
									type: {
										eq: "User"
									}
								}
							}
						}]
					},
					options: {
						ordering: [{
							target: "context",
							property: "datetime",
							order: "desc",
						}],
						edgeGroup: "value",
						limit: 1,
					}
				}, {
					filters: {
						edges: {
							name: {
								eq: "operationBody.externalOperationParams.dataStore"
							}
						},
						meta: {
							type: {
								eq: "OperationRequestObject"
							}
						},
						payload: {
							and: [{
								or: [{
									and: [{
										"operationBody__externalOperationName": {
											eq: "importConnectedRecords"
										},
										"operationBody__connectedAppName": {
											eq: connectedAppName
										},
										"operationBody__externalOperationParams__eelGUID": {
											eq: eelFieldGUID
										},
										"statusUpdates__-1__status": {
											eq: "Done"
										},
										"operationSucessfullyCompleted": {
											eq: true
										}
									}]
								}, {
									and: [{
										"operationBody__externalOperationName": {
											eq: "importConnectedRecords"
										},
										"operationBody__connectedAppName": {
											eq: connectedAppName
										},
										"operationBody__externalOperationParams__eelGUID": {
											eq: eelFieldGUID
										},
										"!statusUpdates__-1__status": {
											eq: "Done"
										},
										"statusUpdates__-1__timestamp": {
											gt: (new Date()).getTime() - vcSelf.$root.VisorGlobalConfig.dataStore.operationRequests.abandonedTimeoutMS
										}
									}]
								}]
							}]
						}
					},
					linkedObjects: {
						includes: [{
							filters: {
								edges: {
									name: {
										eq: "creator",
									}
								},
								meta: {
									type: {
										eq: "User"
									}
								}
							}
						}]
					},
					options: {
						ordering: [{
							target: "context",
							property: "datetime",
							order: "desc",
						}],
						edgeGroup: "value",
						limit: 1,
					}
				}]
			}, []);
			dataStore.$internals.graphManager.filterEdges({
				inboundIncludes: oroFilters
			}, function onLoadBack(edgesBack, {edgeGroups}, ...args) {
				// We actually don't need to do anything here. The oroAggregator will handle the rest for us, cause its the best thing in the world
			});
		},
		majorColumnList(){
			const vcSelf = this;

			// console.log(`Recalc: majorColumnList`);

			if(vcSelf.displayResolutionUnits in SheetViewTypes.types[vcSelf.sheetView.type].resolutions){
				return SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.calculateBaseDateForwardBackArray(
					vcSelf.currentDate,
					vcSelf.displayResolution.attributes,
					vcSelf.additionalDateIncrementsBefore,
					vcSelf.additionalDateIncrementsAfter,
					null,
					null,
					// vcSelf.earliestRecordStartDateMS,
					// vcSelf.latestRecordEndDateMS,
				);
			}
			else{
				Assert.throwError(`Unknown resolution: ${vcSelf.displayResolutionUnits}`)
			}
		},
		minorColumnList(){
			const vcSelf = this;
			const minorList = [];

			// console.log(`Recalc: minorColumnList`);

			for(let majorDateIndex in vcSelf.majorColumnList){
				let minorIncrementArray = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.minorIncrements(vcSelf.majorColumnList[majorDateIndex], vcSelf.displayResolution.attributes);
				minorIncrementArray = minorIncrementArray.map(function getTimeFromDate(date){
					return date.getTime();
				});
				minorList.push(minorIncrementArray);
			}

			return minorList;
		},
	},
	utils:{
		getFilteredActiveRecordsFromArray(arrayOfUnfilteredRecords){
			// currently only used by Timeline view to get records to display

			const vcSelf = this;

			// console.log(`getFilteredActiveRecordsFromArray`)

			//Filter by active
			const activeRecords = arrayOfUnfilteredRecords.filter(function shouldIncludeRecord({record, type}){
				return type === 'newRecord' || (record && record.active);
			});

			let filteredLoadedRecords = activeRecords;

			// console.log(`Filtering through ${filteredLoadedRecords.length} records`)

			//Filter by labels
			//Check if there are filters
			if (vcSelf.sheetView.properties.labels && vcSelf.sheetView.properties.labels.activeLabels) {
				for (let fieldGUID in vcSelf.sheetView.properties.labels.activeLabels) {
					if (vcSelf.sheetView.properties.labels.activeLabels[fieldGUID].filtering.activeFilteredValues.length > 0) {
						// we are filtering by this field
						const fieldType = vcSelf.schemaObject.fields[fieldGUID].field.fieldType;
						filteredLoadedRecords = filteredLoadedRecords.filter(function includedInFilteredList({record, type}) {
							if (type === "newRecord") {
								return true;
							}
							const groupValue = DataStoreFields.fieldTypes[fieldType].features.picklist.getPicklistKeyFromValue({
								value: record.getFieldValue(fieldGUID),
								dataStore: record.dataStore,
								fieldGUID,
								systemState: vcSelf.$root.systemState,
								ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
							});
							if (groupValue) {
								if (Array.isArray(groupValue)) {
									let valueWasFound = false;
									for (let valIndex = 0; !valueWasFound && valIndex < groupValue.length; valIndex++) {
										valueWasFound = valueWasFound || vcSelf.sheetView.properties.labels.activeLabels[fieldGUID].filtering.activeFilteredValues.indexOf(groupValue[valIndex]) >= 0;
									}
									return valueWasFound;
								} else {
									return vcSelf.sheetView.properties.labels.activeLabels[fieldGUID].filtering.activeFilteredValues.indexOf(groupValue) >= 0;
								}
							} else {
								if (vcSelf.sheetView.isPicklistFilteredByBlankValue(fieldGUID)) {
									return true;
								} else {
									return false;
								}
							}
						})
					} else {
						// console.log(`Field ${fieldGUID} is a label but doesnt have filters applied`)
					}
				}
			}
			else{
				// console.log(`No active labels`)
			}

			// console.log(`Returning ${filteredLoadedRecords.length} records`)
			return filteredLoadedRecords;
		}
	},
	computed:{
		filteredLoadedRecords(){
			// TODO: cleanup, not used
			return COMMON_VUE_FUNCTIONS.utils.getFilteredActiveRecordsFromArray.apply(this, [this.loadedRecords.map(function nest(record){
				return {record};
			})]).map(function unNest({record}){
				return record;
			});
		},

		displayRecords(){
			const vcSelf = this;

			return vcSelf.flatRecordDisplayArray.flattenedDisplayArray;
		}, //hadInfiniteCycleBeforeRecalculating
		hasInfiniteCycle() {
			return this.flatRecordDisplayArray.hadInfiniteCycleBeforeRecalculating;
		},
		recordsVisibleInView() {
			return this.flatRecordDisplayArray.recordsVisibleInView;
		},
		flatRecordDisplayArray() {
			const vcSelf = this;
			const output = GridRecordDisplay.getFlatRecordDisplayArray({
				dataStore: vcSelf.dataStore,
				sheetView: vcSelf.sheetView,
				manualRecordSortOrder: vcSelf.manualRecordSortOrder,
				hideUntilLoadCompletes: vcSelf.hideUntilLoadCompletes,
				isLoadingRecords: vcSelf.loadingRecords,
				systemState: vcSelf.$root.systemState,
				ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
			});
			// We send the pubsub here because we want this to always happen with grid enabled views, irrespective of the view.
			BackgroundBus.pub("ActiveSheetView", "recordVisibilityChanged", {
				recordMap: output.recordsVisibleInView
			});
			// Return the output
			return output;
		},
		allRecordsFiltered(){
			// Currently only used by Timeline view
			return COMMON_VUE_FUNCTIONS.utils.getFilteredActiveRecordsFromArray.apply(this, [this.allRecords.map(function getNestingStruct(record){
				return {record};
			})]).map(function unNestStruct({record}){
				return record;
			});
		},
		sortedFields(includeHidden=false){
			const vcSelf = this;

			let nestingMaximumDepth = 1;
			if(vcSelf.displayRecords){
				if(vcSelf.displayRecords.length > 1 && vcSelf.displayRecords[1].nestingGlobalStats){
					nestingMaximumDepth = vcSelf.displayRecords[1].nestingGlobalStats.maximumDepth;
				}
			}


			let fieldList = [];
			const nameFieldGUID = vcSelf.schemaObject.getPrimaryNameFieldGUID();

			function getColumnWidth(fieldGUID){
				let colWidth;
				if(vcSelf.possibleColumnResize && vcSelf.possibleColumnResize.fieldGUID === fieldGUID){
					colWidth = vcSelf.possibleColumnResize.sizePX;
				}
				else{

					let columnSizeStruct = vcSelf.sheetView.getColumnSizeStruct(fieldGUID);
					let fieldType = vcSelf.schemaObject.fields[fieldGUID].field.fieldType;

					if(columnSizeStruct){
						colWidth = columnSizeStruct.colWidth;
					}
					else if(DataStoreFields.fieldTypes[fieldType].display.defaultColumnWidthPX){
						if(typeof(DataStoreFields.fieldTypes[fieldType].display.defaultColumnWidthPX) === 'function'){
							colWidth = DataStoreFields.fieldTypes[fieldType].display.defaultColumnWidthPX({
								sheetView: vcSelf.sheetView,
								dataStore: vcSelf.sheetView.sheetViewGroup.dataStore,
								fieldGUID,
								systemState: vcSelf.$root.systemState,
								ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
							});
						}
						else{
							colWidth = DataStoreFields.fieldTypes[fieldType].display.defaultColumnWidthPX;
						}
					}
					else{
						// debugger;
						colWidth = Config.dataStore.viewTypes.all.defaultTableFieldColumnWidthPX;
					}
				}
				return colWidth;
			}

			for(let fieldGUID in vcSelf.schemaObject.fields){
				if(fieldGUID === nameFieldGUID){
					continue;
				}
				if(includeHidden || !vcSelf.sheetView.isHiddenField(fieldGUID)){
					fieldList.push({
						type: 'field',
						key: fieldGUID,
						properties: vcSelf.schemaObject.fields[fieldGUID],
						widthPX: getColumnWidth(fieldGUID),
					});
				}
			}

			if(!Config.interfaceConfig.debugging.hidePrimaryColumnInGrid){
				// always add the namefield
				fieldList.push({
					type: 'field',
					key: nameFieldGUID,
					properties: vcSelf.schemaObject.fields[nameFieldGUID],
					widthPX: getColumnWidth(nameFieldGUID),
				});
			}

			fieldList.sort(function compare(fieldStructA, fieldStructB){
				if (vcSelf.sheetView.properties) {
					const indexA = vcSelf.sheetView.properties.fields.sortOrder.indexOf(fieldStructA.key);
					const indexB = vcSelf.sheetView.properties.fields.sortOrder.indexOf(fieldStructB.key);
					if (indexA >= 0) {
						if (indexB >= 0) {
							return indexA - indexB;
						} else {
							return -1;
						}
					} else if (indexB >= 0) {
						return 1;
					} else {
						// Meta was newly introduced 8/29/19, so some old fields may not have it
						if(fieldStructA.properties.meta && fieldStructB.properties.meta){
							return fieldStructA.properties.meta.dateAdded - fieldStructB.properties.meta.dateAdded;
						} else {
							return 0;
						}
					}
				} else {
					if (fieldStructA.properties.meta && fieldStructB.properties.meta) {
						return fieldStructA.properties.meta.dateAdded - fieldStructB.properties.meta.dateAdded;
					} else {
						return 0;
					}
				}
			}).sort(function findPrimaryLabel(fieldStructA, fieldStructB) {
				if (vcSelf.sheetView.type === "table") {
					if (fieldStructA.properties.field.attributes.isPrimaryLabel) {
						return -1;
					} else if (fieldStructB.properties.field.attributes.isPrimaryLabel) {
						return 1;
					}
				}
				return 0;
			});
			const retArr = [{
				type: 'first-column',
				key: 'number-column-left',
				widthPX: Math.max(60, (44 + nestingMaximumDepth * 12)),
			}, ...fieldList];

			let includeNewFieldCreation = vcSelf.workbookHasPermission('field_addNew');
			if (includeNewFieldCreation) {
				retArr.push({
					type: 'add-new-field',
					key: 'add-new-field',
					widthPX: 120,
				});
			}

			for(let columnIndex = 0; columnIndex < retArr.length; columnIndex++){
				retArr[columnIndex].masterIndex = columnIndex;
			}

			return retArr;

		}
	},
	subscriptionHandlers:{
		pointerDownInDraggableColumn({pointerDownEvent, relativeColumnIndex}, {elementForRelativeCalculation, considerScrollForPreview = false}){
			const vcSelf = this;

			// console.log(`Start: pointerDownInDraggableColumn`);

			//Reject if this is a resize also!
			if(pointerDownEvent.target.classList.contains('resize-dragger')){
				return;
			}

			//Only left click
			if(pointerDownEvent.button !== 0){
				return;
			}

			//Don't drag on mobile
			if(vcSelf.$root.systemState.experience !== 'desktop'){
				return;
			}

			//Includes the number column and the first fixed column (on table)
			let countOfFixedColumns;
			if (vcSelf.sheetView.type === 'table') {
				countOfFixedColumns = 2;
			} else if(vcSelf.sheetView.type === 'gantt') {
				countOfFixedColumns = 1;
			}

			//Includes the "add column" column
			const countOfEndCapUnsortableColumns = 1;

			//Specifically for the number column at left
			const nonFieldColumnsAtStart = 1;

			//Need to determine which column line this is closest to
			function countColumnsToLeftOfPointer(pointerEvent){
				const pointerX = pointerEvent.clientX;
				const gridAreaLeft = elementForRelativeCalculation.getBoundingClientRect().left;
				const pointerDistanceFromLeftEdgeOfGridArea = Math.max(0, pointerX - gridAreaLeft);

				const gridVirtualScrollLeft = vcSelf.virtualScrolledGridBasePositionX;
				const columns = vcSelf.sortedFields;

				// console.log(`pointerDistanceFromLeftEdgeOfGridArea: ${pointerDistanceFromLeftEdgeOfGridArea}`)

				let columnsPassed = 0;
				let pixelsPassed = 0;
				for(let columnIndex = 0; columnIndex < columns.length - countOfEndCapUnsortableColumns && pixelsPassed < pointerDistanceFromLeftEdgeOfGridArea; columnIndex++){
					const columnWidth = columns[columnIndex].widthPX;
					const columnIsDisplayed = columnIndex < countOfFixedColumns || columnIndex >= countOfFixedColumns + gridVirtualScrollLeft;

					if(columnIsDisplayed){
						if(pixelsPassed + columnWidth < pointerDistanceFromLeftEdgeOfGridArea){
							//The whole column can fit inside
							// console.log(`Column ${columnIndex} is displayed and fully fits inside at ${columnWidth}px`);
							pixelsPassed += columnWidth;
							columnsPassed++;
						}
						else{
							//Only part of the column can fit inside
							// console.log(`Column ${columnIndex} is displayed and partially fits inside at ${columnWidth}px`);
							const pixelsRemainingToMouse = pointerDistanceFromLeftEdgeOfGridArea - pixelsPassed;
							const portionOfColumnPassed = pixelsRemainingToMouse / columnWidth;
							pixelsPassed += pixelsRemainingToMouse;
							columnsPassed += portionOfColumnPassed;
						}
					}
					else{
						//If this column is scrolled out of view, count if but none of it's pixels
						// console.log(`Column ${columnIndex} is NOT displayed but was scrolled left, at ${columnWidth}px`);
						columnsPassed++;
					}
				}
				//Need to adjust if it's to the left of the fixed columns
				const roundedColumnPosition = Math.round(columnsPassed);

				let indicatorDistanceFromLeftEdgeOfGridArea = 0;
				for (let columnIndex = 0; columnIndex < roundedColumnPosition; columnIndex++) {
					const columnIsDisplayed = columnIndex < countOfFixedColumns || columnIndex >= countOfFixedColumns + gridVirtualScrollLeft;
					if (columnIsDisplayed) {
						indicatorDistanceFromLeftEdgeOfGridArea += columns[columnIndex].widthPX;
					}
				}
				const isValidColumnReorder = gridVirtualScrollLeft > 0 || roundedColumnPosition >= countOfFixedColumns;

				return {
					columnsPassed,
					isValidColumnReorder,
					roundedColumnPosition,
					pointerDistanceFromLeftEdgeOfGridArea,
					indicatorDistanceFromLeftEdgeOfGridArea,
				};
			}

			const startX = pointerDownEvent.clientX;
			const minimumDragThreshold = Config.dataStore.viewTypes.table.columns.colReorderDragThresholdPX;
			let hasPassedMinimumDragMagnitude = false;
			let currentX;

			function markPassedMinimumDragMagnitude(){
				hasPassedMinimumDragMagnitude = true;
				// console.log(`Reorder choose: ${vcSelf.sortedFields[relativeColumnIndex].guid}`)
				vcSelf.$pubsub.modules.columnReorder.statefulPubSet('reorderChoose',{
					fieldGUID: vcSelf.sortedFields[relativeColumnIndex].key,
				})

				vcSelf.$pubsub.modules.grid.pub('activateDragScroller', {
					axis: 'x',
				});
			}


			function onMouseMove(mouseEvent){

				if(!hasPassedMinimumDragMagnitude){
					currentX = mouseEvent.clientX;
					if(Math.abs(currentX - startX) >= minimumDragThreshold){
						markPassedMinimumDragMagnitude();
					}
				}

				if(hasPassedMinimumDragMagnitude){
					const {
						columnsPassed,
						roundedColumnPosition,
						pointerDistanceFromLeftEdgeOfGridArea,
						indicatorDistanceFromLeftEdgeOfGridArea,
						isValidColumnReorder,
					} = countColumnsToLeftOfPointer(mouseEvent);
					// console.log(`roundedColumnPosition: ${roundedColumnPosition} and the indicator should be at ${indicatorDistanceFromLeftEdgeOfGridArea}px from left`);
					vcSelf.reorderIndicatorPositionX = indicatorDistanceFromLeftEdgeOfGridArea;
					vcSelf.reorderValid = isValidColumnReorder;
				}

				// console.log(`proposedIndexBefore`, proposedIndexBefore);
			}
			function onMouseUp(mouseEvent){

				if(hasPassedMinimumDragMagnitude){

					const {
						columnsPassed,
						roundedColumnPosition,
						pointerDistanceFromLeftEdgeOfGridArea,
						indicatorDistanceFromLeftEdgeOfGridArea,
						isValidColumnReorder,
					} = countColumnsToLeftOfPointer(mouseEvent);

					// console.log(`roundedColumnPosition: ${roundedColumnPosition}`);

					const proposedIndexBefore = roundedColumnPosition - nonFieldColumnsAtStart;
					const startingColumnLocation = relativeColumnIndex - nonFieldColumnsAtStart;

					let proposedIndexToUse;
					if(proposedIndexBefore > startingColumnLocation){
						proposedIndexToUse = proposedIndexBefore - 1;
					}
					else{
						proposedIndexToUse = proposedIndexBefore;
					}

					// console.log(`Proposed moving from [${relativeColumnIndex}] to [${proposedIndexToUse}]`)

					if(startingColumnLocation !== proposedIndexToUse){

						const possibleSortOrder = vcSelf.sortedFields.slice(nonFieldColumnsAtStart, vcSelf.sortedFields.length - countOfEndCapUnsortableColumns);
						while (startingColumnLocation < 0) {
							startingColumnLocation += possibleSortOrder.length;
						}
						while (proposedIndexToUse < 0) {
							proposedIndexToUse += possibleSortOrder.length;
						}
						if (proposedIndexToUse >= possibleSortOrder.length) {
							var k = proposedIndexToUse - possibleSortOrder.length + 1;
							while (k--) {
								possibleSortOrder.push(undefined);
							}
						}
						possibleSortOrder.splice(proposedIndexToUse, 0, possibleSortOrder.splice(startingColumnLocation, 1)[0]);

						// console.log(possibleSortOrder);
						vcSelf.sheetView.changeColumnSortOrder(possibleSortOrder.map(function getGUID(fieldStruct){
							return fieldStruct.key;
						}));

						vcSelf.$pubsub.modules.columnReorder.pub('reorderMove',{
							possibleSortOrder,
						})
					}


					vcSelf.$pubsub.modules.columnReorder.statefulPubClear('reorderChoose');
					vcSelf.reorderIndicatorPositionX = null;
					vcSelf.reorderValid = isValidColumnReorder;
			}

				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);
				vcSelf.$pubsub.modules.grid.pub('deactivateDragScroller');

				//TODO: Stop the pop menu
			}

			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);

			onMouseMove(pointerDownEvent)
		},
		pointerDownInRecordTableCell({pointerDownEvent, fieldGUID, record, fieldIndex}){
			const vcSelf = this;


			// console.log('pointerDownInRecordTableCell', fieldGUID, record, pointerDownEvent.target);

			if(pointerDownEvent.button !== 0){
				return;
			}

			if(!pointerDownEvent.shiftKey){
				// console.log("Shift key wasn't down, so moving selection");
			}

			let href = pointerDownEvent.target.getAttribute('href');
			// console.log(href);
			if(href && href.length > 0){
				//HRefs don't trigger this, because they have click actions
				return;
				// console.log("Shift key wasn't down, so moving selection");
			}

			let rangeStartRecord = record;
			let rangeStartFieldGUID = fieldGUID;
			let shouldWaitToResetDragSelect;

			let isDragValueAcross = false; // This is used to signal the onMouseUp event to also copy the value of the currently selected cell across the dragged area.
			let clipboardDataPromise;
			if(pointerDownEvent.target.dataset && pointerDownEvent.target.dataset.dragCellCorner && pointerDownEvent.target.dataset.dragCellCorner === "true"){
				// console.log(`isDragValueAcross`);
				isDragValueAcross = true;
				clipboardDataPromise = new Promise(function onComplete(resolve, reject){
					vcSelf.clipboardEventHandler.generateClipboardDataFromDocument(null, null, function withClipboardData(clipboardData){
						resolve(clipboardData);
					});
				});
			}

			let currentHighlightRange = vcSelf.gridSelection.highlightedRanges[0];
			let baseRecordGUIDs = null;
			let baseFieldGUIDS = null;
			if(pointerDownEvent.shiftKey || isDragValueAcross){
				//When shift key pressed, we expand range
				if(currentHighlightRange){
					const recordGUID = record.$internals.metaProperties.meta.guid;
					const allRecordGUIDs = vcSelf.displayRecords.filter(function isRecord({record, type}){
						return record !== null;
					}).map(function getGUID({record}){
						return record.$internals.metaProperties.meta.guid;
					});
					const allFieldGUIDs = vcSelf.sortedFields.filter(function isField(fieldStruct){
						return fieldStruct.type === 'field';
					}).map(function getGUID(fieldStruct){
						return fieldStruct.key;
					});
					const expandedRange = GridCommon.getExpandedHighlightRange(currentHighlightRange, allRecordGUIDs, allFieldGUIDs, recordGUID, fieldGUID);
					let recordGUIDRangeMatches = expandedRange.recordGUIDs.length === currentHighlightRange.recordGUIDs.length && expandedRange.recordGUIDs.every(function(value, index) { return value === currentHighlightRange.recordGUIDs[index]});
					let fieldGUIDRangeMatches = expandedRange.fieldGUIDs.length === currentHighlightRange.fieldGUIDs.length && expandedRange.fieldGUIDs.every(function(value, index) { return value === currentHighlightRange.fieldGUIDs[index]});

					if(!recordGUIDRangeMatches || !fieldGUIDRangeMatches){
						vcSelf.gridSelection.clearHighlight();
						vcSelf.gridSelection.highlightRange(expandedRange.recordGUIDs, expandedRange.fieldGUIDs, "pointer");
					}
					
					baseRecordGUIDs = expandedRange.recordGUIDs;
					baseFieldGUIDS = expandedRange.fieldGUIDs;
				}


				rangeStartRecord = vcSelf.dataStore.getRecordByGUID(vcSelf.gridSelection.selectedCell.recordGUID);
				rangeStartFieldGUID = vcSelf.gridSelection.selectedCell.fieldGUID;

				shouldWaitToResetDragSelect = true;
				requestAnimationFrame(function(){
					// console.log("Calling out to focusRecordCell");
					vcSelf.$pubsub.modules.tableNavigation.pub('focusRecordCell', {
						recordGUIDs: rangeStartRecord.$internals.metaProperties.meta.guid,
						fieldGUID: rangeStartFieldGUID,
					});
					requestAnimationFrame(function(){
						shouldWaitToResetDragSelect = false;
						vcSelf.shiftDragSelectActive = true;
					})
				});


				vcSelf.shiftDragSelectActive = true;
			}
			else{
				shouldWaitToResetDragSelect = false;
				rangeStartRecord = record;
				rangeStartFieldGUID = fieldGUID;
				vcSelf.gridSelection.clearGridSelection();
				vcSelf.gridSelection.highlightCell(record.$internals.metaProperties.meta.guid, fieldGUID);
				vcSelf.gridSelection.setSelectedCell(record.$internals.metaProperties.meta.guid, fieldGUID);
				vcSelf.$el.focus();
			}

			vcSelf.$pubsub.modules.tableNavigation.statefulPubSet('dragHighlight', {
				baseRecordGUIDs,
				baseFieldGUIDS,
				isDragValueAcross
			});

			let mostRecentTargetCell = {fieldGUID, record};

			function getResult(pointerEvent){
				// console.log(pointerEvent);

				let pointerEventPath = [];
				if(pointerEvent && pointerEvent.path){
					pointerEventPath = pointerEvent.path
				}
				else{
					pointerEventPath = pointerEvent.composedPath();
				}

				// console.log('----', pointerEventPath);

				for(let pathItemIndex = 0; pathItemIndex < pointerEventPath.length; pathItemIndex++){
					const element = pointerEventPath[pathItemIndex];
					// console.log(element);
					if(element.dataset && element.dataset.recordguid && element.dataset.fieldguid){
						return {
							fieldGUID:element.dataset.fieldguid,
							record: vcSelf.dataStore.records.find(function matchByGUID(record){
								return record.$internals.metaProperties.meta.guid === element.dataset.recordguid;
							})
						};
					}
				}


				return null;
			}

			function getRangesBetween(recordA, recordB, fieldGUIDA, fieldGUIDB){
				const displayRecordsFlat = vcSelf.displayRecords.filter(function isRecord({record}){
					return record !== null;
				}).map(function getRecord({record}){return record;});
				const indexOfRecordA = displayRecordsFlat.indexOf(recordA);
				const indexOfRecordB = displayRecordsFlat.indexOf(recordB);
				const minRecordIndex = Math.min(indexOfRecordA, indexOfRecordB);
				const maxRecordIndex = Math.max(indexOfRecordA, indexOfRecordB);
				const recordsBetween = displayRecordsFlat.slice(minRecordIndex, maxRecordIndex+1);


				const fieldGUIDsSorted = vcSelf.sortedFields.filter(function isField(fieldStruct){
					return fieldStruct.type === 'field';
				}).map(function getGUID(fieldStruct){
					return fieldStruct.key;
				});
				const indexOfFieldGUIDA = fieldGUIDsSorted.indexOf(fieldGUIDA);
				const indexOfFieldGUIDB = fieldGUIDsSorted.indexOf(fieldGUIDB);
				const minFieldGUIDIndex = Math.min(indexOfFieldGUIDA, indexOfFieldGUIDB);
				const maxFieldGUIDIndex = Math.max(indexOfFieldGUIDA, indexOfFieldGUIDB);
				const fieldGUIDsBetween = fieldGUIDsSorted.slice(minFieldGUIDIndex, maxFieldGUIDIndex+1);

				return {
					records: recordsBetween,
					fieldGUIDs: fieldGUIDsBetween,
				};

			}

			function onMouseMove(pointerEvent){
				// console.log(`MouseMove`);
				const proposedResult = getResult(pointerEvent);
				if(proposedResult){
					mostRecentTargetCell = proposedResult;
				}
				else{
					// console.log(`Mouse over something that didn't trigger cell`, pointerEvent);
				}
				const ranges = getRangesBetween(rangeStartRecord, mostRecentTargetCell.record, rangeStartFieldGUID, mostRecentTargetCell.fieldGUID);
				// console.log(ranges);
				// console.log(proposedResult);
				//Simulate result
				if(ranges){
					currentHighlightRange = vcSelf.gridSelection.highlightedRanges[0];
					const recordGUIDs = ranges.records.map(function getGUID(record){
						return record.$internals.metaProperties.meta.guid;
					});
					const fieldGUIDs = ranges.fieldGUIDs;

					let recordGUIDRangeMatches = currentHighlightRange && recordGUIDs.length === currentHighlightRange.recordGUIDs.length && recordGUIDs.every(function(value, index) { return value === currentHighlightRange.recordGUIDs[index]});
					let fieldGUIDRangeMatches = currentHighlightRange && fieldGUIDs.length === currentHighlightRange.fieldGUIDs.length && fieldGUIDs.every(function(value, index) { return value === currentHighlightRange.fieldGUIDs[index]});

					if(!recordGUIDRangeMatches || !fieldGUIDRangeMatches){
						// console.log(`Clearing highight beause mouse moved to new range`);
						vcSelf.gridSelection.clearHighlight();
						vcSelf.gridSelection.highlightRange(recordGUIDs, fieldGUIDs, "drag");
					}
					else{
						// console.log(`Same range`);
					}
					// console.log("Selecting range",recordGUIDs, fieldGUIDs )
				}
				else{
					// console.log(`No ranges`);
				}
			}

			function onMouseUp(pointerEvent){
				// console.log("Mouseup");
				const proposedResult = getResult(pointerEvent);
				// console.log(proposedResult);
				if(proposedResult){
					mostRecentTargetCell = proposedResult;
				}
				const ranges = getRangesBetween(rangeStartRecord, mostRecentTargetCell.record, rangeStartFieldGUID, mostRecentTargetCell.fieldGUID);
				if(ranges){
					const recordGUIDs = ranges.records.map(function getGUID(record){
						return record.$internals.metaProperties.meta.guid;
					});
					const fieldGUIDs = ranges.fieldGUIDs;

					if(isDragValueAcross){
						// console.log(`Should copy values into the range`);

						if(recordGUIDs.length > 1 || fieldGUIDs.length > 1){
							clipboardDataPromise.then(function withClipboardData(clipboardData){
								vcSelf.clipboardEventHandler.handleClipboardPasteEvent(null, clipboardData, { overrideRecordGUIDs: recordGUIDs, overrideFieldGUIDs: fieldGUIDs, overrideFocus: true, overrideFill: true });
							});
						}
					}
					vcSelf.$pubsub.modules.tableNavigation.statefulPubClear('dragHighlight');

					vcSelf.gridSelection.clearHighlight();
					vcSelf.gridSelection.highlightRange(recordGUIDs, fieldGUIDs, "pointer");

				}
				endEvent();
			}

			function endEvent(){
				vcSelf.$pubsub.modules.grid.pub('deactivateDragScroller');
				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);
				document.removeEventListener('keydown', keydownListener);
				if(!shouldWaitToResetDragSelect){
					vcSelf.shiftDragSelectActive = false;
				}
			}

			function keydownListener(keyEvent){
				if(keyEvent.key === 'Escape' || keyEvent.key === 'Esc'){
					endEvent();
				}
			}

			vcSelf.$pubsub.modules.grid.pub('activateDragScroller', {
				axis: 'both',
			});

			onMouseMove(pointerDownEvent);

			document.addEventListener('keydown', keydownListener)
			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);

		},
		pointerDownInCanvasRecord({pointerDownEvent, dateType, isFullDrag, scrollContainerQuerySelector}){
			const vcSelf = this;

			//Reject if not the primary button
			if(pointerDownEvent.button !== 0){
				return;
			}

			vcSelf.mouseDownOnRecord = (isFullDrag ? 'drag' : `resize-${dateType}`);
			vcSelf.$pubsub.modules.records.pub('mouseDownOverRecord', {});

			const scrollContainer = document.querySelector(scrollContainerQuerySelector);

			if(!scrollContainer){
				Assert.throwWarning(`pointerDownInCanvasRecord: Could not find scroll container to consider scroll position`);
			}

			const rawHadBothDates = vcSelf.rawHasBothDates;
			const scrollContainerScrollLeftStart = scrollContainer.scrollLeft;
			const ganttScrollXAtStart = vcSelf.sheetView.type === 'gantt' ? vcSelf.scrollPositionX : 0;
			// let originalScrollPositionX = vcSelf.scrollPositionX; //Only for gantt right now
			let draggingStartX = pointerDownEvent.screenX;
			let draggingStartY = pointerDownEvent.screenY;
			let currentX, currentY, movedDistanceX, movedDistanceY, proposedDate, fieldGUIDToChange, complementaryDateType, complementaryFieldGUIDToChange, complementarySideDateValue, startingDateValue;
			let recordDragStartEdgePositionX, dateFinderOffset;
			let originalDuration, originalDurationValidIncrements;
			let hasPassedDragThreshold = false;
			let selectedGroupFieldType;
			let canAddNewPicklistChoice;
			let canChangePicklistChoice;
			let currentRecordGroupValue;
			let lastMouseEvent = pointerDownEvent;

			const originalLeftDate = vcSelf.leftDate;
			const originalRightDate = vcSelf.rightDate;

			//Applies only for gantt
			const hadNoDates = vcSelf.hasNoDates;

			if(vcSelf.sheetView.type === 'timeline'){
				const isSwimlaneFieldProtected = vcSelf.isSwimlaneFieldProtected;
				selectedGroupFieldType = vcSelf.schema.fields[vcSelf.selectedGroupFieldGUID].field.fieldType;
				canAddNewPicklistChoice = DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.canAddChoice && !isSwimlaneFieldProtected;

				if(typeof(DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.canChangeValue) === 'function'){
					canChangePicklistChoice = DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.canChangeValue({
						sheetView: vcSelf.sheetView,
						dataStore: vcSelf.sheetView.sheetViewGroup.dataStore,
						systemState: vcSelf.$root.systemState,
						fieldGUID: vcSelf.selectedGroupFieldGUID,
						ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
					});
				}
				else{
					canChangePicklistChoice = DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.canChangeValue;
				}
				canChangePicklistChoice = canChangePicklistChoice && !isSwimlaneFieldProtected;

				currentRecordGroupValue = DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.getPicklistKeyFromValue({
					value: vcSelf.record.getFieldValue(vcSelf.selectedGroupFieldGUID),
					dataStore: vcSelf.record.dataStore,
					fieldGUID: vcSelf.selectedGroupFieldGUID,
					systemState: vcSelf.$root.systemState,
					ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
				});
			}

			if(dateType === 'startDate'){
				recordDragStartEdgePositionX = vcSelf.offsetX;
				dateFinderOffset = -1 * vcSelf.dateMinorIncrementWidthPX / 2;
				startingDateValue = DateUtil.dateFormat(vcSelf.leftDate, 'isoDate');
				fieldGUIDToChange = vcSelf.startDateFieldGUID;
				complementaryDateType = 'endDate';
				complementaryFieldGUIDToChange = vcSelf.endDateFieldGUID;
				complementarySideDateValue = DateUtil.parseDate(DateUtil.dateFormat(vcSelf.rightDate, 'isoDate')+' 0:0:0');
			}
			if(dateType === 'endDate'){
				recordDragStartEdgePositionX = vcSelf.endX;
				dateFinderOffset = vcSelf.dateMinorIncrementWidthPX / 2; //(vcSelf.dateMinorIncrementWidthPX * 1 / 2);
				startingDateValue = DateUtil.dateFormat(vcSelf.rightDate, 'isoDate');
				fieldGUIDToChange = vcSelf.endDateFieldGUID;
				complementaryDateType = 'startDate';
				complementaryFieldGUIDToChange = vcSelf.startDateFieldGUID;
				complementarySideDateValue = DateUtil.parseDate(DateUtil.dateFormat(vcSelf.leftDate, 'isoDate')+' 0:0:0');
			}

			if(isFullDrag){
				// originalDuration = vcSelf.endDate.getTime() - vcSelf.startDate.getTime();
				originalDurationValidIncrements = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.calculateValidMinorIncrementsBetween(vcSelf.leftDate, vcSelf.rightDate, vcSelf.sheetView.properties.display.resolution.attributes);
			}

			function updateRecordChangeEvent(){
				vcSelf.$pubsub.modules.records.statefulPubSet('recordChange', {
					record: vcSelf.record,
					startDate: originalLeftDate,
					endDate: originalRightDate,
					groupIndex: vcSelf.groupIndex,
					laneIndex: vcSelf.laneIndex,
					rowIndex: vcSelf.index,
					hadNoDates,
				});
			}

			function passedThreshold(){
				hasPassedDragThreshold = true;
				updateRecordChangeEvent();
			}


			function findDestinationDate(dateStart, xPosition){
				// console.log(`findDestinationDate: ${xPosition}px from ${dateStart}`);
				const incrementsDragged = Math.round(xPosition / vcSelf.dateMinorIncrementWidthPX);
				// console.log(`Dragged increments: ${incrementsDragged}`);
				const suggestedDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsAhead(dateStart, incrementsDragged, vcSelf.sheetView.properties.display.resolution.attributes);
				// console.log(`Suggested date: ${suggestedDate}`);
				return suggestedDate;
			}

			function countLanesBeforeOrAfter(yPixels){
				const rowHeight = Config.dataStore.viewTypes[vcSelf.sheetView.type].rowHeightPX;
				const magnitude = Math.abs(yPixels);
				const direction = yPixels / magnitude;
				const numberOfLanesMagnitude = Math.round(magnitude / rowHeight);

				// console.log("canAddNewPicklistChoice", canAddNewPicklistChoice);
				// console.log("canChangePicklistChoice", canChangePicklistChoice);

				let additionalLaneForNewChoice;
				if(canAddNewPicklistChoice){
					additionalLaneForNewChoice = 1;
				}
				else{
					additionalLaneForNewChoice = 0;
				}

				let availableLanesBeforeSelf, availableLanesAfterSelf;

				if(canChangePicklistChoice){
					availableLanesBeforeSelf = vcSelf.lanesBeforeSelf;
					availableLanesAfterSelf = vcSelf.lanesAfterSelf;
				}
				else{
					availableLanesBeforeSelf = vcSelf.lanesBeforeSelfInGroup;
					availableLanesAfterSelf = vcSelf.lanesAfterSelfInGroup;
				}

				// console.log("availableLanesBeforeSelf", availableLanesBeforeSelf);
				// console.log("availableLanesAfterSelf", availableLanesAfterSelf);

				if(numberOfLanesMagnitude > 0){

					let boundedNumberOfLanesMagnitude;
					if(yPixels > 0){
						//Plus 1 at the end so we allow dragging into the new row at the bottom
						boundedNumberOfLanesMagnitude = Math.min(numberOfLanesMagnitude, availableLanesAfterSelf + additionalLaneForNewChoice);
					}
					else{
						boundedNumberOfLanesMagnitude = Math.min(numberOfLanesMagnitude, availableLanesBeforeSelf);
					}

					let lanesDifferenceProposed = boundedNumberOfLanesMagnitude * direction;

					// console.log(`${yPixels} - (Mag:${numberOfLanesMagnitude}) (after:${vcSelf.lanesAfterSelf}) (before:${vcSelf.lanesBeforeSelf})`)

					return lanesDifferenceProposed;

				}
				return 0;
			}

			function getGroupAndLaneMatchingOffset(laneOffset){

				const targetLaneIndex = vcSelf.lanesBeforeSelf + 1 + laneOffset;

				// console.log(`Lanes Before Self: ${vcSelf.lanesBeforeSelf} - laneOffset: ${laneOffset}`)

				let targetLaneCountdown = targetLaneIndex;
				let group;
				//Add lanes in previous groups

				// canChangePicklistChoice

				for(let groupIndexIncrement = 0; groupIndexIncrement <= vcSelf.groupsAndLanes.length; groupIndexIncrement++){
					group = vcSelf.groupsAndLanes[groupIndexIncrement] || null;
					// console.log(`Considering ${group.group.groupValue} at ${groupIndexIncrement} with ${targetLaneCountdown} lanes left to go`)
					if(group && group.lanes.length > 0){
						for(let laneIndexIncrement in group.lanes){
							targetLaneCountdown--;
							if(targetLaneCountdown === 0){
								return {
									group: group,
									groupIndex: groupIndexIncrement,
									lane: group.lanes[laneIndexIncrement],
									laneIndex: parseInt(laneIndexIncrement),
								};
							}
						}
					}
					else{
						//Each group has one default lane if none are specified
						targetLaneCountdown--;
						if(targetLaneCountdown === 0){
							return {
								group: group,
								groupIndex: groupIndexIncrement,
								lane: null,
								laneIndex: null,
							};
						}
					}
				}
			}

			function onMouseMove(mouseMoveEvent){
				// console.log(`-----MOUSEMOVE------`)
				lastMouseEvent = mouseMoveEvent;				

				let ganttOffset = 0;
				if(vcSelf.sheetView.type === 'gantt'){
					const ganttScrollXNow = vcSelf.scrollPositionX;
					ganttOffset = (ganttScrollXAtStart - ganttScrollXNow) * vcSelf.dateMinorIncrementWidthPX					
				}

				currentX = mouseMoveEvent.screenX;
				movedDistanceX = currentX - draggingStartX - (scrollContainerScrollLeftStart - scrollContainer.scrollLeft) - ganttOffset;

				if(!hasPassedDragThreshold && Math.abs(movedDistanceX) > Config.dataStore.viewTypes.timeline.dragThresholdPX){
					passedThreshold();
				}

				if(isFullDrag){
					//Check for moving to new group / lane
					currentY = mouseMoveEvent.screenY;
					movedDistanceY = currentY - draggingStartY;

					if(!hasPassedDragThreshold && Math.abs(movedDistanceY) > Config.dataStore.viewTypes[vcSelf.sheetView.type].dragThresholdPX){
						passedThreshold();
					}
				}


				// console.log(movedDistanceX, hasPassedDragThreshold)

				//Don't combine with above -- not just when it's passed, but any time after it's passed this executes
				if(hasPassedDragThreshold){
					// console.log(`movedDistanceX - ${movedDistanceX}`);

					const scrollX = recordDragStartEdgePositionX + movedDistanceX;

					// console.log(`scrollX - ${scrollX}`)


					if(dateType === 'startDate'){
						proposedDate = findDestinationDate(originalLeftDate, movedDistanceX);
					}
					if(dateType === 'endDate'){
						proposedDate = findDestinationDate(originalRightDate, movedDistanceX);
					}


					// console.log(`proposedDate - ${proposedDate}`)

					if(isFullDrag){

						//The below logic appears to have been added in order to keep the item within the bounds of the old style of dragging
						//But with the new style, it might not be needed, so this will be commented out
						// let latestStartDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsBehind(new Date(vcSelf.latestDateMS), originalDurationValidIncrements, vcSelf.sheetView.properties.display.resolution.attributes);
						// proposedDate = new Date(Math.min(latestStartDate.getTime(), proposedDate.getTime()));
					}
					else{
						if(dateType === 'startDate'){
							proposedDate = new Date(Math.min(vcSelf.rightDate.getTime(), proposedDate.getTime()));
						}
						if(dateType === 'endDate'){
							proposedDate = new Date(Math.max(vcSelf.leftDate.getTime(), proposedDate.getTime()));
							proposedDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getLastDateInIncrement(proposedDate, vcSelf.sheetView.properties.display.resolution.attributes);
						}
					}
					const isStartDateProtected = vcSelf.isStartDateProtected;
					const isEndDateProtected = vcSelf.isEndDateProtected;
					if (dateType === "startDate" && isStartDateProtected) {
						proposedDate = originalLeftDate;
					} else if (dateType === "startDate" && isFullDrag && isEndDateProtected) {
						proposedDate = originalLeftDate;
					} else if (dateType === "endDate" && isEndDateProtected) {
						proposedDate = originalRightDate;
					}
					// console.log(`proposedDate after min - ${proposedDate}`)

					// console.log(`proposedDate - ${proposedDate}`)

					// console.log(`formatted - ${DateUtil.dateFormat(proposedDate, 'isoDate')}`)


					vcSelf.simulateValues[dateType] = DateUtil.parseDate(DateUtil.dateFormat(proposedDate, 'isoDate')+' 0:0:0');

					if(isFullDrag){
						// vcSelf.simulateValues.endDate = new Date(vcSelf.simulateValues[dateType].getTime() + originalDuration);
						vcSelf.simulateValues.endDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsAhead(vcSelf.leftDate, originalDurationValidIncrements, vcSelf.sheetView.properties.display.resolution.attributes);
						vcSelf.simulateValues.endDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getLastDateInIncrement(vcSelf.simulateValues.endDate, vcSelf.sheetView.properties.display.resolution.attributes);

						// console.log(currentY, draggingStartY);

						// console.log(movedDistanceY, hasPassedDragThreshold)

						if(vcSelf.sheetView.type === 'timeline'){
							let laneDifferenceMagnitudeProposed = countLanesBeforeOrAfter(movedDistanceY)

							vcSelf.simulateValues.laneMagnitudeDifference = laneDifferenceMagnitudeProposed;

							if(laneDifferenceMagnitudeProposed !== 0){
								let proposedGroupAndLane = getGroupAndLaneMatchingOffset(laneDifferenceMagnitudeProposed);
								// console.log(`Proposed: ${proposedGroupAndLane.group.group.groupValue}`)

								if(proposedGroupAndLane.groupIndex === vcSelf.groupsAndLanes.length){
									vcSelf.simulateValues.groupFieldValue = null;
								}
								else{
									vcSelf.simulateValues.groupFieldValue = proposedGroupAndLane.group.group.groupValue;
								}

							}
							else{
								vcSelf.simulateValues.groupFieldValue = null;
							}
						}
					}
					else if(vcSelf.rawHasNoDates){
						vcSelf.simulateValues[complementaryDateType] = complementarySideDateValue;
					}

					updateRecordChangeEvent();

					// console.log(`Simulate: `, vcSelf.simulateValues.startDate, vcSelf.simulateValues.endDate);
				}
			}

			function onMouseUp(mouseUpEvent){

				// console.log(`-----MOUSEUP------`)

				if(hasPassedDragThreshold){
					currentX = mouseUpEvent.screenX;

					let ganttOffset = 0;
					if(vcSelf.sheetView.type === 'gantt'){
						const ganttScrollXNow = vcSelf.scrollPositionX;
						ganttOffset = (ganttScrollXAtStart - ganttScrollXNow) * vcSelf.dateMinorIncrementWidthPX					
					}

					movedDistanceX = currentX - draggingStartX - (scrollContainerScrollLeftStart - scrollContainer.scrollLeft) - ganttOffset;

					if(dateType === 'startDate'){
						proposedDate = findDestinationDate(originalLeftDate, movedDistanceX);
					}
					if(dateType === 'endDate'){
						proposedDate = findDestinationDate(originalRightDate, movedDistanceX);
					}


					if(isFullDrag){
						//See note above about similar block
						// let latestStartDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsBehind(new Date(vcSelf.latestDateMS), originalDurationValidIncrements, vcSelf.sheetView.properties.display.resolution.attributes);
						// proposedDate = new Date(Math.min(latestStartDate.getTime(), proposedDate.getTime()));
					}
					else{
						if(dateType === 'startDate'){
							proposedDate = new Date(Math.min(vcSelf.rightDate.getTime(), proposedDate.getTime()));
						}
						if(dateType === 'endDate'){
							proposedDate = new Date(Math.max(vcSelf.leftDate.getTime(), proposedDate.getTime()));
							proposedDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getLastDateInIncrement(proposedDate, vcSelf.sheetView.properties.display.resolution.attributes);
						}
					}
					
					const isStartDateProtected = vcSelf.isStartDateProtected;
					const isEndDateProtected = vcSelf.isEndDateProtected;
					if (dateType === "startDate" && isStartDateProtected) {
						proposedDate = originalLeftDate;
					} else if (dateType === "startDate" && isFullDrag && isEndDateProtected) {
						proposedDate = originalLeftDate;
					} else if (dateType === "endDate" && isEndDateProtected) {
						proposedDate = originalRightDate;
					}

					vcSelf.simulateValues[dateType] = null;
					vcSelf.simulateValues[complementaryDateType] = null;

					const proposedValue = DateUtil.dateFormat(proposedDate, 'isoDate');

					// console.log(`proposedValue - ${proposedValue}`)

					if(proposedValue !== startingDateValue || !rawHadBothDates){

						let hadNoDates = vcSelf.rawHasNoDates;

						vcSelf.record.changeField(fieldGUIDToChange, proposedValue);
						if(isFullDrag){
							let proposedEndDateDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsAhead(vcSelf.leftDate, originalDurationValidIncrements, vcSelf.sheetView.properties.display.resolution.attributes);

							proposedEndDateDate = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getLastDateInIncrement(proposedEndDateDate, vcSelf.sheetView.properties.display.resolution.attributes);

							let proposedEndDate = DateUtil.dateFormat(proposedEndDateDate, 'isoDate')
							vcSelf.record.changeField(vcSelf.endDateFieldGUID, proposedEndDate);
						}
						else if(hadNoDates){
							vcSelf.record.changeField(complementaryFieldGUIDToChange, DateUtil.dateFormat(complementarySideDateValue, 'isoDate'));
						}
						vcSelf.$pubsub.modules.UI.pub('actionTaken', {
							actionClass: 'dataStoreTimelineUI',
							action: 'draggedDate',
							details: {
								record: vcSelf.record,
								dateType,
								fieldGUID: vcSelf.endDateFieldGUID,
							},
						});
					}

					//Always check if changed group/lane
					if(isFullDrag && vcSelf.sheetView.type === 'timeline'){
						currentY = mouseUpEvent.screenY;
						movedDistanceY = currentY - draggingStartY;

						let laneDifferenceMagnitudeProposed = countLanesBeforeOrAfter(movedDistanceY)

						vcSelf.simulateValues.laneMagnitudeDifference = laneDifferenceMagnitudeProposed;

						if(laneDifferenceMagnitudeProposed !== 0){
							let proposedGroupAndLane = getGroupAndLaneMatchingOffset(laneDifferenceMagnitudeProposed);

							let changingGroup = false;

							// const canAddNewPicklistChoice = DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.canAddChoice;

							if(proposedGroupAndLane.groupIndex === vcSelf.groupsAndLanes.length){
								//This is going into the new group
								if(canAddNewPicklistChoice){
									changingGroup = true;
									const createdPicklistValue = vcSelf.sheetGlobalState.dataStore.addPicklistValue(vcSelf.sheetView.properties.fields.groupBy, 'Untitled');

									DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.changeRecordPicklistValue({
										record: vcSelf.record,
										fieldGUID: vcSelf.selectedGroupFieldGUID,
										value: createdPicklistValue,
										referenceValue: null,
										systemState: vcSelf.$root.systemState,
										ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
									});
								}
								else{
									Assert.throwError('Tried adding new timeline row for picklist-like field that does not support adding new choices');
								}
							}
							else{
								if(proposedGroupAndLane.group.group.groupValue !== currentRecordGroupValue){
									changingGroup = true;

									DataStoreFields.fieldTypes[selectedGroupFieldType].features.picklist.changeRecordPicklistValue({
										record: vcSelf.record,
										fieldGUID: vcSelf.selectedGroupFieldGUID,
										value: proposedGroupAndLane.group.group.groupValue,
										referenceValue: proposedGroupAndLane.group.group.referenceValue,
										systemState: vcSelf.$root.systemState,
										ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
									});
								}

								vcSelf.sheetView.addRecordToTimelineLane(vcSelf.record, vcSelf.selectedGroupFieldGUID, proposedGroupAndLane.group.group.groupValue, proposedGroupAndLane.laneIndex);
							}

							vcSelf.$pubsub.modules.UI.pub('actionTaken', {
								actionClass: 'dataStoreTimelineUI',
								action: 'draggedRecord',
								details: {
									record: vcSelf.record,
								},
							});
						}
					}
				}

				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);
				vcSelf.$pubsub.modules.canvas.unsub('scrolledDates', onDatesScrolled);


				vcSelf.simulateValues.endDate = null;
				if(vcSelf.sheetView.type === 'timeline'){
					vcSelf.simulateValues.laneMagnitudeDifference = 0;;
				}
				vcSelf.mouseDownOnRecord = false;

				vcSelf.$pubsub.modules.records.statefulPubClear('recordChange');

				if(!hasPassedDragThreshold){
					// console.log(`records.recordModalOpen`, vcSelf.record);
					vcSelf.$pubsub.modules.records.pub('recordModalOpen', {
						record: vcSelf.record,
					});
				}

				vcSelf.$pubsub.modules.records.pub('mouseUpOverRecord', {});
			}

			function onDatesScrolled(){
				// console.log(`Dates scrolled`);
				onMouseMove(lastMouseEvent);
			}

			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);
			vcSelf.$pubsub.modules.canvas.sub('scrolledDates', onDatesScrolled);

			onMouseMove(pointerDownEvent)
			// console.log(`records.recordChangeActive`, vcSelf.record);
		},
		pointerDownInMinorIncrement({pointerDownEvent, rowIndex, groupIndex, laneIndex, record, majorDateIndex, minorDateIndex, scrollContainerQuerySelector, parentRecord, dragOffsetPX}){
			const vcSelf = this;

			//Reject if button was not primary button
			if(pointerDownEvent.button !== 0){
				return;
			}


			// console.log(arguments[0]);

			const sheetType = vcSelf.sheetView.type;

			const pointerDownTimestamp = Date.now();

			let scrollContainer = document.querySelector(scrollContainerQuerySelector);
			let scrollContainerScrollLeftStart = scrollContainer.scrollLeft;

			if(!scrollContainer){
				Assert.throwWarning(`pointerDownInCanvasRecord: Could not find scroll container to consider scroll position`);
			}

			vcSelf.$pubsub.modules.canvas.pub('hideMinorIncrementDatePreview');

			if(record){
				vcSelf.$pubsub.modules.canvas.statefulPubSet('addingDatesToRecord', {
					record,
				});
			}

			vcSelf.minorIncrementDatePreviewsActive = false;

			const pointerDownDate = vcSelf.minorColumnList[majorDateIndex][minorDateIndex];
			const startX = pointerDownEvent.screenX;
			let currentX, dragDistance, dragMagnitude, dragDirection, dragMinorIncrements, dateIncrements, startDate, dateDraggedTo, endDate;
			let lastMouseEvent = pointerDownEvent;

			let isCreatingInNewGroup = false;

			if(sheetType === 'timeline' && groupIndex === vcSelf.groupsAndLanes.length){
				isCreatingInNewGroup = true;
			}

			const forwardDragCorrectionPx = 0; //-1 * Config.dataStore.viewTypes.timeline.dateMinorIncrementWidthPX / 2;

			function getDateDraggedTo(dateIncrements, dragDirection){
				let currentMajorIncrement = majorDateIndex;
				let currentMinorIncrement = minorDateIndex;


				let loopMajorIncrement = currentMajorIncrement;
				let loopMinorIncrement = currentMinorIncrement;

				for(let incrementsPassed = 0; incrementsPassed < dateIncrements; incrementsPassed++){
					if(loopMinorIncrement + dragDirection < vcSelf.minorColumnList[loopMajorIncrement].length && loopMinorIncrement + dragDirection >= 0){
						loopMinorIncrement += dragDirection;
					}
					else{
						if(loopMajorIncrement + dragDirection < vcSelf.minorColumnList.length && loopMajorIncrement + dragDirection >= 0){
							loopMajorIncrement += dragDirection;
							if(dragDirection > 0){
								loopMinorIncrement = 0
							}
							else{
								loopMinorIncrement = vcSelf.minorColumnList[loopMinorIncrement].length - 1;
							}
						}
						else{
							return vcSelf.minorColumnList[loopMajorIncrement][loopMinorIncrement];
						}
					}
				}

				return 	vcSelf.minorColumnList[loopMajorIncrement][loopMinorIncrement];

			}

			function getSimulatedRecordDetails(mouseEvent, minimumProjectSize = 0){
				const containerRect = scrollContainer.getBoundingClientRect();
				const mouseClientLeft = mouseEvent.clientX;
				const containerClientLeft = containerRect.left + (dragOffsetPX || 0); //This is to accomodate timelines left fixed area for now
				const containerScrollLeft = scrollContainer.scrollLeft;
				const mouseDistanceFromContainerLeftEdge = Math.max(0, mouseClientLeft - containerClientLeft + containerScrollLeft);
				const incrementsFromLeftEdge = Math.trunc(mouseDistanceFromContainerLeftEdge / vcSelf.dateMinorIncrementWidthPX);

				// console.log('containerClientLeft', containerClientLeft);
				// console.log('containerScrollLeft', containerScrollLeft);
				// console.log('mouseDistanceFromContainerLeftEdge', mouseDistanceFromContainerLeftEdge);
				// console.log('incrementsFromLeftEdge', incrementsFromLeftEdge);

				// Find what date that's over
				let incrementsToPass = incrementsFromLeftEdge;
				let foundDate = null;
				for(let majorIndex = 0; majorIndex < vcSelf.minorColumnList.length; majorIndex++){
					// console.log(`At major index: ${majorIndex}`);
					if(vcSelf.minorColumnList[majorIndex].length <= incrementsToPass){
						incrementsToPass -= vcSelf.minorColumnList[majorIndex].length;
						// console.log(`This whole major fits in, so incrementsToPass is now ${incrementsToPass}`);
					}
					else{
						// console.log(`Only part of this fits in, so taking our date`);
						foundDate = vcSelf.minorColumnList[majorIndex][incrementsToPass];
						break;
					}
				}

				//Make it the last date if it's off right edge
				if(!foundDate){
					const lastMajorIncrement = vcSelf.minorColumnList[vcSelf.minorColumnList.length - 1];
					foundDate = lastMajorIncrement[lastMajorIncrement.length - 1];
				}

				dragMagnitude = foundDate - pointerDownDate;
				dragDirection = dragMagnitude ? dragMagnitude / Math.abs(dragMagnitude) : 0;

				// console.log('foundDate', foundDate);
				// console.log('dragMagnitude', dragMagnitude);
				// console.log('dragDirection', dragDirection);

				let minimumDateAhead;

				if(minimumProjectSize > 0){
					minimumDateAhead = SheetViewTypes.types[vcSelf.sheetView.type].resolutions[vcSelf.displayResolutionUnits].calculations.getDateValidIncrementsAhead(
						new Date(pointerDownDate),
						minimumProjectSize * dragDirection,
						vcSelf.sheetView.properties.display.resolution.attributes,
					).getTime();
				}
				else{
					minimumDateAhead = pointerDownDate;
				}

				if(dragDirection > 0){
					dateDraggedTo = Math.max(minimumDateAhead, foundDate);
				}
				else{
					dateDraggedTo = Math.min(minimumDateAhead, foundDate);
				}

				// console.log('dateDraggedTo', dateDraggedTo);

				if(dragDirection > 0){
					startDate = pointerDownDate;
					endDate = dateDraggedTo;
				}
				else{
					startDate = dateDraggedTo;
					endDate = pointerDownDate;
				}

				return {
					rowIndex,
					startDate,
					endDate,
					groupIndex,
					laneIndex,
					isGhost: false,
				};


				return;



				currentX = mouseEvent.screenX;
				dragDistance = currentX - startX - (scrollContainerScrollLeftStart - (scrollContainer ? scrollContainer.scrollLeft : 0));

				//Don't allow no width to be shown
				if(dragDistance === 0){
					dragDistance = 1;
				}

				dragMagnitude = Math.abs(dragDistance);

				dragDirection = dragDistance / dragMagnitude;

				if(dragDirection > 0 && dragDirection + forwardDragCorrectionPx > 0){
					dragMagnitude += forwardDragCorrectionPx;
				}

				dateIncrements = Math.max(Math.trunc(dragMagnitude / vcSelf.dateMinorIncrementWidthPX), minimumProjectSize);

				//Default to 1 increment
				// dateIncrements = Math.max(0, dateIncrements);

				if(dragMagnitude !== 0){
					dateDraggedTo = getDateDraggedTo(dateIncrements, dragDirection);

					// console.log(`Dragged from ${pointerDownDate} by ${dragDirection * dateIncrements} to ${dateDraggedTo}`)

					if(dragDistance > 0){
						startDate = pointerDownDate;
						endDate = dateDraggedTo;
					}
					else{
						startDate = dateDraggedTo;
						endDate = pointerDownDate;
					}

					return {
						rowIndex,
						startDate,
						endDate,
						groupIndex,
						laneIndex,
						isGhost: false,
					};
				}

				return null;
			}

			function onMouseMove(mouseMoveEvent){
				lastMouseEvent = mouseMoveEvent;
				vcSelf.simulateRecordCreation = getSimulatedRecordDetails(mouseMoveEvent);
			}

			function onMouseUp(mouseUpEvent){

				const pointerUpTimestamp = Date.now();

				const pointerClickDuration = pointerUpTimestamp - pointerDownTimestamp;

				let minimumProjectSize = 0;
				if(pointerClickDuration < 150){
					minimumProjectSize = 2;
				}

				let possibleRecordCreation = getSimulatedRecordDetails(mouseUpEvent, minimumProjectSize);

				if(possibleRecordCreation){

					if(sheetType === 'timeline' && isCreatingInNewGroup){
						//Create the new group
						vcSelf.sheetGlobalState.dataStore.addPicklistValue(vcSelf.sheetView.properties.fields.groupBy, 'Untitled');
					}

					const fieldGUIDs = {
						startFieldGUID: vcSelf.sheetView.properties.fields.startDate,
						endFieldGUID: vcSelf.sheetView.properties.fields.endDate,
						groupFieldGUID: vcSelf.sheetView.properties.fields.groupBy,
					};


					const fieldValues = {
						[fieldGUIDs.startFieldGUID]:{
							value: DateUtil.dateFormat(new Date(possibleRecordCreation.startDate), 'isoDate'),
						},
						[fieldGUIDs.endFieldGUID]:{
							value: DateUtil.dateFormat(new Date(possibleRecordCreation.endDate), 'isoDate'),
						},
					};

					let groupValue;

					if(sheetType === 'timeline'){
						groupValue = vcSelf.groupsAndLanes[possibleRecordCreation.groupIndex].group.groupValue;
						fieldValues[fieldGUIDs.groupFieldGUID] = {
							value: groupValue,
						};
					}

					if(record){
						//Update the record we have
						for(let fieldGUID in fieldValues){
							record.changeField(fieldGUID, fieldValues[fieldGUID].value);
						}

						vcSelf.$pubsub.modules.UI.pub('actionTaken', {
							actionClass: 'dataStoreGanttUI',
							action: 'draggedToSetDates',
							details: {
								record,
							},
						})

						vcSelf.$pubsub.modules.records.pub('recordModalOpen', {
							record,
						});
					}
					else{

						if(parentRecord){
							const parentFieldGUID = vcSelf.sheetGlobalState.dataStore.getOrCreateChildToParentNestingFieldGUID();
							fieldValues[parentFieldGUID] = {
								value: parentRecord.$internals.metaProperties.meta.guid,
							};
						}

						//Add a new records
						const recordInitialValues = vcSelf.sheetView.generateInitialRecordValuesFromActiveFilters(vcSelf.$root.systemState, vcSelf.sheetGlobalState.ConnectedApps);
						const createdRecord = vcSelf.sheetGlobalState.dataStore.addNewRecord('Untitled', Object.assign(recordInitialValues, fieldValues));

						if(sheetType === 'timeline'){
							vcSelf.sheetView.addRecordToTimelineLane(createdRecord, fieldGUIDs.groupFieldGUID, groupValue, possibleRecordCreation.laneIndex);
						}

						vcSelf.$pubsub.modules.records.pub('recordModalOpen', {
							record: createdRecord,
						});

						vcSelf.$pubsub.modules.UI.pub('actionTaken', {
							actionClass: 'dataStoreTimelineUI',
							action: 'draggedToCreateRecord',
							details: {
								record: createdRecord,
							},
						});
					}

				}
				endCreation();

			}

			function keydownListener(keyEvent){
				if(keyEvent.key === 'Escape' || keyEvent.key === 'Esc'){
					endCreation();
				}
			}

			function onDatesScrolled(){
				onMouseMove(lastMouseEvent);
			}

			function endCreation(){
				vcSelf.simulateRecordCreation = null;

				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);
				document.removeEventListener('keydown', keydownListener);
				vcSelf.$pubsub.modules.canvas.unsub('scrolledDates', onDatesScrolled);
				vcSelf.$pubsub.modules.canvas.pub('showMinorIncrementDatePreview');
				if(record){
					vcSelf.$pubsub.modules.canvas.statefulPubClear('addingDatesToRecord');
				}
				vcSelf.minorIncrementDatePreviewsActive = true;
			}

			document.addEventListener('keydown', keydownListener)
			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);
			vcSelf.$pubsub.modules.canvas.sub('scrolledDates', onDatesScrolled);

			onMouseMove(pointerDownEvent)
		},
		pointerDownInRecordRowGrabber({pointerDownEvent, record, rowIndex, recordIndex, elementForRelativeCalculation, startCalculatingAfterPx = 0}){
			const vcSelf = this;

			Assert.isTrue(recordIndex !== undefined, 'Need a recordindex for starting');

			//Reject if button was not primary button
			if(pointerDownEvent.button !== 0){
				return;
			}


			// Reject if we dont have the ability to editValues
			// This is because if the user decides to nest this row we need to edit a value in a column
			// TODO: this should be temporary, we really need to do this on mouseup
			if(!vcSelf.dataStore.hasPermission('record_editValues')){
				return;
			}

			const sheetViewHierarchy = vcSelf.sheetView.properties.display && vcSelf.sheetView.properties.display.hierarchy;
			const sheetViewHierarchyRootLevel = (sheetViewHierarchy ? sheetViewHierarchy.rootLevel || 0 : 0);
			const sheetViewHierarchyDepth = (sheetViewHierarchy && sheetViewHierarchy.depth !== null ? sheetViewHierarchy.depth : Number.MAX_SAFE_INTEGER);

			vcSelf.$pubsub.modules.canvas.pub('hideMinorIncrementDatePreview');

			const nestingGUID = vcSelf.dataStore.getChildToParentNestingFieldGUID();

			const recordParent = record.getParentRecord(nestingGUID);

			let hasPassedDragThreshold = false;
			const initialPointerDownY = pointerDownEvent.clientY;
			const pointerDownTimeout = setTimeout(function onTimeoutFired(){
				triggerPassedThreshold();
			}, Config.dataStore.viewTypes.all.gridRowDragTimeThresholdMS);

			let lastMouseEvent = pointerDownEvent;
			let hasPreviewActive = false;

			function triggerPassedThreshold(){
				if(!hasPassedDragThreshold){
					hasPassedDragThreshold = true;
					vcSelf.$pubsub.modules.records.statefulPubSet('recordManualSort', {
						record,
						recordIndex,
						rowIndex,
					});
					if(!hasPreviewActive){
						onMouseMove(lastMouseEvent);
					}
					clearTimeout(pointerDownTimeout);
				}
			}

			const dragRowDetails = vcSelf.displayRecords[rowIndex];

			function calculateRowIndexAtPointer(mouseEvent){
				const clientY = mouseEvent.clientY;
				const elementRelativeTop = elementForRelativeCalculation.getBoundingClientRect().top;
				const mouseYRelativeToTopOfContainer = clientY - elementRelativeTop + elementForRelativeCalculation.scrollTop - startCalculatingAfterPx;

				// console.log("mouseYRelativeToTopOfContainer", mouseYRelativeToTopOfContainer);

				// if(mouseYRelativeToTopOfContainer > 150){
				// 	debugger;
				// }

				/*
					Determine which row within the display the mouse is over.
					Remember that the displayRecords area may have scrolled or shifted since the drag began.
				*/

				let countOfRowsPast = 0;
				let pixelsRemainingToMouse = mouseYRelativeToTopOfContainer;

				//Assumes the first row is fixed, because that's the header
				const fixedRows = 1;
				const visibleRecordArray = [...vcSelf.displayRecords.slice(0, fixedRows), ...vcSelf.displayRecords.slice(vcSelf.virtualScrolledGridBasePositionY + fixedRows)];

				for(let row = 0; row < visibleRecordArray.length && pixelsRemainingToMouse > 0; row++){
					const heightOfRow = visibleRecordArray[row].heightPX;
					if(heightOfRow <= pixelsRemainingToMouse){
						countOfRowsPast++;
					}
					else{
						countOfRowsPast += (pixelsRemainingToMouse / heightOfRow);
					}
					// console.log(`Row ${row} had height ${heightOfRow}px and dropped the pixels remaining from ${pixelsRemainingToMouse} to ${pixelsRemainingToMouse - heightOfRow}`);
					pixelsRemainingToMouse -= heightOfRow;
				}

				const numberOfFixedRows = 1; //the header
				countOfRowsPast = Math.min(Math.max(numberOfFixedRows, countOfRowsPast), visibleRecordArray.length - 1);
				// console.log(`countOfRowsPast: ${countOfRowsPast}`)

				const numberOfRowsFromTop = Math.trunc(countOfRowsPast);
				const dragOverArea = Math.trunc((countOfRowsPast - numberOfRowsFromTop) * 3);

				// console.log(`numberOfRowsFromTop is: ${numberOfRowsFromTop} and dragOverArea is ${dragOverArea}`);

				const dropRowDetails = visibleRecordArray[numberOfRowsFromTop];
				const dropRowRecordIndex = dropRowDetails.flatArrayRecordIndex;

				// console.log(`Drag started at row ${rowIndex}, record ${recordIndex} and has gone to row ${dropRowDetails.flatArrayIndex}, record ${dropRowRecordIndex} - sector ${dragOverArea}`);


				let isValidDrop = true;
				let dropParent = null, dropRow = dropRowRecordIndex, dropDepth = 0;
				//In any case may need to reset parent
				if(dropRowDetails && dropRowDetails.type === 'existingRecord'){
					if(dropRowDetails.record === null){
						dropParent = dropRowDetails.parentRecord;
					}
					else if(record === dropRowDetails.record){
						dropParent = dropRowDetails.parentRecord;
						dropRow++;
					}
					else if(dragOverArea === 0){
						//Slot before indicated row

						/*
							Behavior pattern below is:

							A - Special case at root, keep original parent
							B - Normal case, accept parent at drop location as own parent
							B - Normal case, accept parent at drop location as own parent
							B - Normal case, accept parent at drop location as own parent
						*/

						//Reordering at the top row
						if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot === 1){
							dropParent = dragRowDetails.parentRecord;
						}

						//Dragging something from top to go deeper
						else if(dropRowDetails.depthFromDisplayedRoot !== 1 && dragRowDetails.depthFromDisplayedRoot === 1){
							dropParent = dropRowDetails.parentRecord;
						}

						//Dragging something higher
						else if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot !== 1){
							dropParent = dropRowDetails.parentRecord;
						}
						//Dragging something from one nested parent to another
						else{
							dropParent = dropRowDetails.parentRecord;
						}

					}
					else if(dragOverArea === 1){
						//Slot inside indicated row (first sort position)
						//If this row already has children, just put this in position 0
						//If this row has no children, just add it as a child and ensure triangle is open to show it
						dropParent = dropRowDetails.record;
						dropRow++;

					}
					else if(dragOverArea === 2){
						//Slot below indicatted row
						//If this row already has children and is open, slot in as first child in position 0
						//If this row has children but is closed, slot after the row on same level

						if(dropRowDetails.childDetails && dropRowDetails.childDetails.childCount > 0){

							//These are all the same result, but just making that explicit for now

							/*
								Behavior pattern below is:

								A - Normal case, accept drop location as new parent
								A - Normal case, accept drop location as new parent
								A - Normal case, accept drop location as new parent
								A - Normal case, accept drop location as new parent
							*/

							//Reordering at the top row
							if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot === 1){
								dropParent = dropRowDetails.record;
							}
							//Dragging something from top to go deeper
							else if(dropRowDetails.depthFromDisplayedRoot !== 1 && dragRowDetails.depthFromDisplayedRoot === 1){
								dropParent = dropRowDetails.record;
							}
							//Dragging something higher
							else if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot !== 1){
								dropParent = dropRowDetails.record;
							}
							else{
								dropParent = dropRowDetails.record;
							}
						}
						else{

							/*
								Behavior pattern below is:

								A - Special case at root, keep original parent
								B - Normal case, accept parent at drop location as own parent
								B - Normal case, accept parent at drop location as own parent
								B - Normal case, accept parent at drop location as own parent
							*/

							//Reordering at the top row
							if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot === 1){
								dropParent = dragRowDetails.parentRecord;
							}
							//Dragging something from top to go deeper
							else if(dropRowDetails.depthFromDisplayedRoot !== 1 && dragRowDetails.depthFromDisplayedRoot === 1){
								dropParent = dropRowDetails.parentRecord;
							}
							//Dragging something higher
							else if(dropRowDetails.depthFromDisplayedRoot === 1 && dragRowDetails.depthFromDisplayedRoot !== 1){
								dropParent = dropRowDetails.parentRecord;
							}
							else{
								dropParent = dropRowDetails.parentRecord;
							}
						}
						dropRow++;
					}
					else{
					}
				}
				else{
					isValidDrop = false;
				}

				if(dropParent && (dropParent === record || dropParent.getParentChain().indexOf(record) >= 0)){
					isValidDrop = false;
				}

				dropDepth = dropParent ? dropParent.getParentChain().length + 1 : 0;

				// console.log(`Row ${numberOfRows} at position ${dragOverArea} will nest under ${dropParent ? dropParent.getDisplayLabel() : ''}`);
				// console.log(`dropRow !== recordIndex && dropRow !== recordIndex + 1 ::: ${dropRow !== recordIndex && dropRow !== recordIndex + 1}`)
				// console.log(`dropRow: ${dropRow} --- recordIndex: ${recordIndex}`)
				// console.log(`dropParent !== recordParent :: ${dropParent !== recordParent}`)

				return {
					rowNumber: dropRow,
					rowChanged: (dropRow !== recordIndex && dropRow !== recordIndex + 1) || dropParent !== recordParent,
					indent: dropDepth,
					dropParent,
					dragOverArea,
					dropRowDetails,
					destinationParent: dropParent,
					isValidDrop,
				}

			}

			function onMouseMove(mouseMoveEvent) {
				lastMouseEvent = mouseMoveEvent;
				if(hasPassedDragThreshold){
					const { rowNumber, indent, dragOverArea, dropRowDetails, destinationParent, isValidDrop, rowChanged } = calculateRowIndexAtPointer(mouseMoveEvent);
					// Assuming momentarily that nested dropping is in fact allowed
					let isNestingChangeAllowed = true;
					// Define our current parent's record, and our destination parent's record
					let recordParentGUID = recordParent !== null && recordParent !== undefined ? recordParent.$internals.metaProperties.meta.guid : "";
					let destinationParentGUID = destinationParent !== null && destinationParent !== undefined ? destinationParent.$internals.metaProperties.meta.guid : "";
					// If we have a difference in parent, it logically follows that a nesting change is poised to occur. However, if the nesting parent field is protected, this nesting change is invalid
					if (recordParentGUID !== destinationParentGUID && nestingGUID !== null && nestingGUID !== undefined && vcSelf.sheetView.sheetViewGroup.isFieldProtected(nestingGUID)) {
						isNestingChangeAllowed = false; // Therefore, nested dropping is not allowed
					}
					hasPreviewActive = true;
					vcSelf.$pubsub.modules.recordReorderPreview.pub('previewDetailsChanged', {
						rowNumber,
						indent,
						dropRowDetails,
						isValidDrop: isValidDrop && isNestingChangeAllowed,
						destinationParent,
						rowChanged,
					});
				}
				//This should be after the if above because it will call this function again once we pass threshold
				if(!hasPassedDragThreshold && Math.abs(mouseMoveEvent.clientY - initialPointerDownY) > Config.dataStore.viewTypes.all.gridRowDragThresholdPX){
					triggerPassedThreshold();
				}
			}

			function onMouseUp(mouseUpEvent){
				if(hasPassedDragThreshold){
					const {rowNumber, indent, dragOverArea, dropRowDetails, destinationParent, isValidDrop, rowChanged} = calculateRowIndexAtPointer(mouseUpEvent);
					// Assuming momentarily that nested dropping is in fact allowed
					let isNestingChangeAllowed = true;
					// Define our current parent's record, and our destination parent's record
					let recordParentGUID = recordParent !== null && recordParent !== undefined ? recordParent.$internals.metaProperties.meta.guid : "";
					let destinationParentGUID = destinationParent !== null && destinationParent !== undefined ? destinationParent.$internals.metaProperties.meta.guid : "";
					// If we have a difference in parent, it logically follows that a nesting change is poised to occur. However, if the nesting parent field is protected, this nesting change is invalid
					if (recordParentGUID !== destinationParentGUID && nestingGUID !== null && nestingGUID !== undefined && vcSelf.sheetView.sheetViewGroup.isFieldProtected(nestingGUID)) {
						isNestingChangeAllowed = false; // Therefore, nested dropping is not allowed
					}
					let indexMoveTo = rowNumber;

					if (isValidDrop && isNestingChangeAllowed) {
						let destinationIndex;
						if(indexMoveTo > recordIndex){
							destinationIndex = indexMoveTo - 1;
						}
						else{
							destinationIndex = indexMoveTo;
						}

						if(destinationIndex !== recordIndex || (destinationParent !== record.getParentRecord(nestingGUID))){

							const currentOrder = vcSelf.displayRecords.filter(function withRecStruct({record}){
								return !!record;
							}).map(function mapToGUID({record}){
								return record.$internals.metaProperties.meta.guid;
							});

							let changedOrder = currentOrder.slice();

							changedOrder.splice(destinationIndex, 0, changedOrder.splice(recordIndex, 1)[0]);

							vcSelf.sheetView.storeRecordManualSortOrder(changedOrder);

							const systemState = vcSelf.$root.systemState;

							const dropTargetsParentDiffersFromOwn = destinationParent !== record.getParentRecord(nestingGUID);
							const isDroppingAtHighestShownLevel = indent === 0;
							const isDroppingHigher = dragRowDetails.depth > dropRowDetails.depth;
							const highestLevelShownIsRoot = sheetViewHierarchyRootLevel === 0;
							
							if(dropTargetsParentDiffersFromOwn){

								if(isDroppingAtHighestShownLevel && isDroppingHigher && !highestLevelShownIsRoot){
									//Special case where we may need to get a reasonable parent so it can still show up in the view									
									const dropRowRecord = dropRowDetails.record;
									if(dropRowRecord){
										const dropRowsParentRecord = dropRowRecord.getParentRecord(nestingGUID);
										if(dropRowsParentRecord){
											const destinationParentValue = dropRowsParentRecord.$internals.metaProperties.meta.guid;

											vcSelf.$pubsub.modules.toaster.pub("makeToast", {
												message: [{
													label: `1 item changed nesting parent to`,
													props: {
														class: "p-typography-regular-14 p-typography-inline",
														style: {
															marginRight: "0px"
														}
													}
												}, {
													label: dropRowsParentRecord.getDisplayLabel(systemState),
													props: {
														class: "p-typography-bold-14 p-typography-inline",
														style: {
															marginLeft: "0px",
															paddingLeft: "0px"
														}
													}
												}],
												type: "standard",
												location: "bottom-left",
												duration: 5000,
											});
											record.changeField(nestingGUID, destinationParentValue);
											// Ensure that new depth is visible and the triangle is open
											vcSelf.sheetView.ensureRecordChildrenVisibleInHierarchy(dropRowsParentRecord);

										} else {
											// Could not move
											// This would be a problem, because if we're dropping at the highest level, which isn't the root level, we expect
											// All items at the highest shown level (including our dropRowDetails) to have a parent
											debugger;
										}
									} else {
										// Could not move
										// It would be really erroneous if we didn't have a dropRowRecord
										debugger;
									}
								} else if (highestLevelShownIsRoot || !isDroppingAtHighestShownLevel) {
									const destinationParentValue = destinationParent ? destinationParent.$internals.metaProperties.meta.guid : null;
									const childToParentNestingFieldGUID = vcSelf.dataStore.getOrCreateChildToParentNestingFieldGUID();
									if (destinationParent) {
										vcSelf.$pubsub.modules.toaster.pub("makeToast", {
											message: [{
												label: `1 item nested below`,
												props: {
													class: "p-typography-regular-14 p-typography-inline",
													style: {
														marginRight: "0px"
													}
												}
											}, {
												label: destinationParent.getDisplayLabel(systemState),
												props: {
													class: "p-typography-bold-14 p-typography-inline",
													style: {
														marginLeft: "0px",
														paddingLeft: "0px"
													}
												}
											}],
											type: "standard",
											location: "bottom-left",
											duration: 5000,
										});
										//Ensure that new depth is visible and the triangle is open
										vcSelf.sheetView.ensureRecordChildrenVisibleInHierarchy(destinationParent);
									} else {
										vcSelf.$pubsub.modules.toaster.pub("makeToast", {
											message: [{
												label: `1 item unlinked from its parent`,
												props: {
													class: "p-typography-regular-14 p-typography-inline",
													style: {
														marginRight: "0px"
													}
												}
											}],
											type: "standard",
											location: "bottom-left",
											duration: 5000,
										});
									}
									record.changeField(childToParentNestingFieldGUID, destinationParentValue);
								}								
							}
						}
					}

					// vcSelf.recordReorderIndex = null;
					// vcSelf.recordReorderPreview = null;
					hasPreviewActive = false;
					vcSelf.$pubsub.modules.recordReorderPreview.pub('previewDetailsChanged', null)

					vcSelf.$pubsub.modules.records.statefulPubClear('recordManualSort');
				}

				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);

				clearTimeout(pointerDownTimeout);

				vcSelf.$pubsub.modules.canvas.pub('showMinorIncrementDatePreview');
			}


			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);

			// onMouseMove(pointerDownEvent)

		},
		pointerDownInIncrementHeaderReziser({pointerDownEvent, incrementIndex, elementForRelativeCalculation}){
			const vcSelf = this;

			//Reject if button was not primary button
			if(pointerDownEvent.button !== 0){
				return;
			}

			//Will calcualte relative to the
			let elementRelativeLeft, elementScrollLeft;

			elementRelativeLeft = elementForRelativeCalculation.getBoundingClientRect().left;
			elementScrollLeft = elementForRelativeCalculation.scrollLeft;

			// console.log(`Starting at elementRelativeLeft: ${elementRelativeLeft}`);

			const startClientX = pointerDownEvent.clientX;
			const startElementX = startClientX - elementRelativeLeft + elementScrollLeft;
			const minorIncrementsInside = vcSelf.minorColumnList[incrementIndex].length;
			const startingWidth = vcSelf.dateMinorIncrementWidthPX;

			let currentClientX, currentElementX, dragDistance, dragDistancePerIncrement, currentProposedWidth, cursorPosition, cursorShownDragDistance;

			function calculatePosition(pointerEvent){

				elementRelativeLeft = elementForRelativeCalculation.getBoundingClientRect().left;
				currentClientX = pointerEvent.clientX;
				elementScrollLeft = elementForRelativeCalculation.scrollLeft;
				currentElementX = currentClientX - elementRelativeLeft + elementScrollLeft;
				dragDistance = currentElementX - startElementX;
				// console.log(`dragDistance - ${dragDistance}`);

				dragDistancePerIncrement = dragDistance / minorIncrementsInside;

				currentProposedWidth = Math.max(Math.min(
						Config.dataStore.viewTypes.timeline.dateMinorIncrementWidth.maxPX,
						startingWidth + dragDistancePerIncrement,
						), Config.dataStore.viewTypes.timeline.dateMinorIncrementWidth.minPX);


				cursorShownDragDistance = (currentProposedWidth - startingWidth) * minorIncrementsInside + startElementX;


				return {
					currentProposedWidth,
					cursorShownDragDistance,
				}

			}

			function onMouseMove(pointerEvent){
				let proposed = calculatePosition(pointerEvent);
				vcSelf.incrementResizePosition = cursorShownDragDistance;
				// console.log(proposed);
			}

			function onMouseUp(pointerEvent){
				let proposed = calculatePosition(pointerEvent);
				// console.log(proposed);
				vcSelf.sheetView.resizeTimelineMinorIncrements(proposed.currentProposedWidth);
				endResize();
			}

			function endResize(){
				vcSelf.incrementResizePosition = null;
				document.removeEventListener('pointermove', onMouseMove);
				document.removeEventListener('pointerup', onMouseUp);
				document.removeEventListener('keydown', keydownListener);
			}

			function keydownListener(keyEvent){
				if(keyEvent.key === 'Escape' || keyEvent.key === 'Esc'){
					endResize();
				}
			}

			onMouseMove(pointerDownEvent);

			document.addEventListener('keydown', keydownListener)
			document.addEventListener('pointermove', onMouseMove);
			document.addEventListener('pointerup', onMouseUp);
		},
		insertRecordAtIndex({index, parentRecord, onComplete}){

			const vcSelf = this;

			let countOfNonRecordRows = 0;
			for(let displayIndex=0; displayIndex < index; displayIndex++){
				if(vcSelf.displayRecords[displayIndex].record === null){
					countOfNonRecordRows += 1;
				}
			}

			const currentOrder = vcSelf.displayRecords.filter(function isRecord({record}){
				return !!record;
			}).map(function mapToGUID({record}){
				return record.$internals.metaProperties.meta.guid;
			});

			let recordInitialValues = vcSelf.sheetView.generateInitialRecordValuesFromActiveFilters(vcSelf.$root.systemState, vcSelf.sheetGlobalState.ConnectedApps);

			const nestingFieldGUID = vcSelf.dataStore.getChildToParentNestingFieldGUID();

			if(nestingFieldGUID){

				let parentRecordGUID = null;

				if(parentRecord){
					parentRecordGUID = parentRecord.$internals.metaProperties.meta.guid;
				}

				recordInitialValues[nestingFieldGUID] = {
					value: parentRecordGUID,
				};
			}

			let changedOrder = currentOrder.slice();

			const newlyCreatedRecord = vcSelf.dataStore.addNewRecord('Untitled', recordInitialValues);

			changedOrder.splice(index - countOfNonRecordRows, 0, newlyCreatedRecord.$internals.metaProperties.meta.guid);

			vcSelf.sheetView.storeRecordManualSortOrder(changedOrder);

			vcSelf.$nextTick(function afterTick(){
				vcSelf.$pubsub.modules.tableNavigation.pub('focusRecordField', {
					record: newlyCreatedRecord,
					fieldGUID: vcSelf.dataStore.meta.schema.getPrimaryNameFieldGUID(),
				});

				if (onComplete) {
					onComplete(newlyCreatedRecord);
				}
			});
		},
		insertNestedRecord({parentRecord, onComplete}){
			const vcSelf = this;

			const parentRecordGUID = parentRecord.$internals.metaProperties.meta.guid;
			const recordInitialValues = vcSelf.sheetView.generateInitialRecordValuesFromActiveFilters(vcSelf.$root.systemState, vcSelf.sheetGlobalState.ConnectedApps);
			const nestingFieldGUID = vcSelf.dataStore.getChildToParentNestingFieldGUID();

			if(nestingFieldGUID && parentRecordGUID){
				const newRecordValues = Object.assign({
					[nestingFieldGUID]: {
						value: parentRecordGUID,
					}
				}, recordInitialValues);
				const newlyCreatedRecord = vcSelf.dataStore.addNewRecord('Untitled', newRecordValues);

				vcSelf.$nextTick(function afterTick(){
					vcSelf.$pubsub.modules.tableNavigation.pub('focusRecordField', {
						record: newlyCreatedRecord,
						fieldGUID: vcSelf.dataStore.meta.schema.getPrimaryNameFieldGUID(),
					});

					if (onComplete) {
						onComplete(newlyCreatedRecord);
					}
				})

				// TODO: even with the nextTick, the field isnt opened and editable at this point
				// vcSelf.$nextTick(function afterTick(){
				// 	vcSelf.$pubsub.modules.tableNavigation.pub('focusRecordField', {
				// 		record: newlyCreatedRecord,
				// 		fieldGUID: vcSelf.dataStore.meta.schema.getPrimaryNameFieldGUID(),
				// 	});
				// })
			}
			else{
				console.warn(`insertNestedRecord could not be completed. nestingFieldGUID: [${nestingFieldGUID}] parentRecordGUID: [${parentRecordGUID}]`);
			}
		}
	},
};

export default COMMON_VUE_FUNCTIONS;